import React, { useContext, useRef } from "react";
import { Context } from "../../context/Context";
import {
  handleBackgroundColor,
  handleBackgroundNoFill,
} from "../../utils/update.utils";
import ColorPicker from "../ColorPicker/ColorPicker";

export default function Background() {
  const {handleUpdate, state, setState } = useContext(Context);
  const fileUpload = useRef(null);
  return (
    <div className="mt-5 w-full">
      <span className="text-sm text-gray-600 font-medium inline-block">
        BACKGROUND
      </span>
      <br />
      <div className="grid grid-cols-4 gap-4 w-full mt-3">
        <div className="w-14 h-14 relative mr-3">
          <input
            type="radio"
            id={"background-nofill"}
            name="background"
            className="appearance-none transform  outline-none -translate-y-1/2 -translate-x-1/2 absolute left-1/2 top-1/2 w-14 h-14 "
            checked={state.theme.backgroundNoFill}
            value={state.theme.backgroundNoFill}
            onChange={(e) => setState(handleBackgroundNoFill(state))}
          />
          <label
            htmlFor={"background-nofill"}
            className="absolute top-0 left-0 hover:shadow-lg w-14 h-14  rounded-md border   p-2 cursor-pointer outline-none transition transition-duration-300 ease-out"
          >
            <div className="w-full h-full ri-blur-off-fill text-xl flex items-center justify-center text-gray-400"></div>
          </label>
        </div>
        <input
          type="file"
          ref={fileUpload}
          onChange={(e) =>
            setState(handleBackgroundColor(e.target.files[0], state, "image"))
          }
          hidden
          accept="image/*"
        />
        {/* Image Upload */}
        <button
          className="hover:shadow-lg w-14 h-14  rounded-md border   p-2 cursor-pointer outline-none transition transition-duration-300 ease-out"
          onClick={() => fileUpload.current.click()}
        >
          <div className="w-full h-full ri-image-add-fill text-xl flex items-center justify-center text-gray-400"></div>
        </button>
        {/* Color Picker */}
        <ColorPicker />
        {state?.theme?.background?.map(
          ({ id, value, selected, custom, image }) => (
            // <button className="hover:shadow-lg w-14 h-14  rounded-md border    p-2 cursor-pointer focus:border-indigo-400 outline-none transition transition-duration-300 ease-out">
            //   <div className={`w-full h-full rounded-sm ${gradient.value}`}></div>
            // </button>
            <div className="w-14 h-14 relative mr-3 " key={value}>
              <input
                type="radio"
                id={id}
                name="background"
                className="appearance-none transform  outline-none -translate-y-1/2 -translate-x-1/2 absolute left-1/2 top-1/2 w-14 h-14 "
                checked={selected}
                value={value}
                onChange={(e) =>
                  setState(
                    handleUpdate(e.target.value, state, ["theme", "background"])
                  )
                }
              />
              <label
                htmlFor={id}
                className="absolute top-0 left-0 hover:shadow-lg w-14 h-14  rounded-md border   p-2 cursor-pointer outline-none transition transition-duration-300 ease-out"
              >
                {image ? (
                  <img
                    src={value}
                    alt=""
                    className="w-full h-full rounded-sm object-cover"
                  />
                ) : (
                  <div
                    style={custom ? { background: value } : null}
                    className={`w-full h-full rounded-sm bg-gradient-to-br ${
                      custom ? "" : value
                    }`}
                  ></div>
                )}
              </label>
            </div>
          )
        )}
      </div>
    </div>
  );
}
